import React, { useEffect, useMemo } from 'react'
import { useState } from 'react';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { Stack } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { LoadingScreen } from 'src/components/loading-screen';
import FormProvider from 'src/components/hook-form';
import EmailTemplate from 'src/sections/email-template/view/email-template';
import { shortlistCandidates } from 'src/services/candidate.service';
import { enqueueSnackbar } from 'notistack';

const validTillOptions = [];
for (let i = 1; i <= 30; i++) {
    validTillOptions.push(`${i} Day${i !== 1 ? 's' : ''}`);
}

const ShowEmailTemplate = ({ jobId, candidateSelected, setCandidateSelected }) => {

    const [isSubmitting, setIsSubmitting] = useState(false);

    const defaultValues = useMemo(
        () => ({
            sendEmail: true,
            valid_for: validTillOptions[6],
        }),
        [],
    );
    const Schema = Yup.object().shape({
        sendEmail: Yup.bool(),
        valid_for: Yup.string(),
    });
    const Methods = useForm({
        resolver: yupResolver(Schema),
        defaultValues: defaultValues,
    });
    const [methods, setMethods] = useState(Methods);
    const { reset, setValue, handleSubmit, watch } = methods;
    watch();


    const onSubmit = handleSubmit(async (data, event) => {
        try {
            setIsSubmitting(true);
            const reqBody = {
                should_send_email: data.sendEmail,
                valid_for: parseInt(data.valid_for),
                user_list: candidateSelected
            };
            const res = await shortlistCandidates(jobId, reqBody);
            console.log(res);
            if (res.success === true) {
                enqueueSnackbar(data.sendEmail ? 'Email Sent Successfully' : 'Interview created Successfully!');
                setIsSubmitting(false);
                setCandidateSelected(null);
            } else {
                enqueueSnackbar({ message: "Error in creating interview", variant: "error" })
            }
        } catch (error) {
            console.log(error);
        }
    });

    return (
        <>
            {isSubmitting && (
                <Stack sx={{ height: '100%', display: 'flex', justifyContent: 'center' }}>
                    <LoadingScreen loadingText="Adding candidates in the workflow" />
                </Stack>
            )}
            {!isSubmitting &&
                <FormProvider methods={methods} onSubmit={onSubmit}>
                    <Grid
                        sx={{ display: 'flex', justifyContent: 'center' }}
                        container
                        spacing={3}
                    >
                        <EmailTemplate
                            heading="Interview Setup"
                            onBackClick={() => { setCandidateSelected(null) }}
                            methods={methods}
                            isSubmitting={isSubmitting}
                            validTillOptions={validTillOptions}
                            items={candidateSelected}
                            type={candidateSelected.length > 1 ? "bulkShortlist": "singleShortlist"}
                        // files={files}
                        // inputFileType={inputFileType}
                        />
                    </Grid>
                </FormProvider>
            }
        </>
    )
}

export default ShowEmailTemplate;